import React, { useCallback, useState, useEffect, useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import "./ehr.css";
import Divider from "@material-ui/core/Divider";
import { Input } from "../../style/Input";
import { LoginLabel } from "../../style/Label";
import HorizontalOne from "../../assets/Ads/Horizontal.jpeg";
import { LoginHeading, SecondHeading, Container, LoginSection, FlexForm, LoginFormArea } from "../../style/Login";
import { CustomDiv } from "../../style/shared";
import { Button } from "../../style/Button";
import { AiOutlinePlusCircle } from "react-icons/ai";
import { Ad } from "../../style/Home";
import Plus from "../../assets/ehrlogin/newehr.png";
import AdvertiserCard from "../common/card";
import { useHistory } from "react-router-dom";
import { verifyAuth } from "../../authverify";
import Medizen from "../NewCreativeAds/Medizen";
import Primera from "../NewCreativeAds/Primera";
import Panaz from "../NewCreativeAds/Panaz";
import Mycontext from "../../store/Mycontext";
import PrimeraAd from "../../assets/ehrlogin/Primera.jpg";
import MedizenAd from "../../assets/ehrlogin/Medizen.jpg";
import PanazAd from "../../assets/ehrlogin/Panaz.jpg";

import { htmls, values } from "../../constants";
import { TextField } from "@mui/material";
import { Grid } from "@material-ui/core";

const loginAds = {
  1: <Medizen />,
  2: <Primera />,
  3: <Panaz />,
};

const loginAds1 = {
  1: MedizenAd,
  2: PrimeraAd,
  3: PanazAd,
};

function getModalStyle() {
  const top = 50;
  const left = 50;
  return {
    top: `${top}%`,
    left: `${left}%`,
    width: "100%",
    height: "100%",

    transform: `translate(-${top}%, -${left}%)`,
  };
}

const useStyles = makeStyles((theme) => ({
  paper: {
    display: "flex",
    maxWidth: "100%",
    minHeight: "100%",
    backgroundColor: theme.shadows[5],
    borderRadius: "10px",
    // boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    outline: "none",
  },
  loginPaper: {
    marginLeft: "auto",
    marginRight: "auto",
    marginTop: "10%",
    width: "maxContent",
    height: "25%",
    backgroundColor: theme.palette.background.paper,
    borderRadius: "5px",
    // boxShadow: theme.shadows[5],
    padding: "70px 120px 70px 120px",
    outline: "none",
    [theme.breakpoints.down('md')]: {
      width: "80%",
      padding: "50px 80px",
    },
    [theme.breakpoints.down('sm')]: {
      width: "90%",
      padding: "30px 40px",
    },
    [theme.breakpoints.down('xs')]: {
      width: "100%",
      padding: "20px 20px 50px",
    },
  },
}));

const EhrLogin = (props) => {
  const classes = useStyles();
  // getModalStyle is not a pure function, we roll the style only on the first render
  const [modalStyle] = React.useState(getModalStyle);
  const [open, setOpen] = React.useState(false);
  const [bannerType, setBannerType] = React.useState(null);

  const { randValue, setRandValue } = useContext(Mycontext);
  const adConfig = localStorage.getItem("creativeConfig")
    ? JSON.parse(localStorage.getItem("creativeConfig"))
    : null;
  const showAd =
    adConfig && adConfig.workflowWithAdds
      ? adConfig.workflowWithAdds.includes("Login")
      : false;

  const history = useHistory();
  if (!verifyAuth()) {
    history.push({
      pathname: "/",
    });
  }
  const handleOnClick = useCallback(() => history.push("/Welcome"), [history]);

  const handleOpen = () => {
    console.log(
      "clicked inside plus button",
      JSON.parse(localStorage.getItem("creativeConfig"))
    );
    setOpen(true);
    let newRandValue = Math.floor(Math.random() * 3) + 1;
    while (
      (newRandValue === 1 || newRandValue === 2) &&
      adConfig &&
      adConfig.messaging_sparks.length &&
      !adConfig.messaging_sparks.includes("Rep") &&
      !adConfig.messaging_sparks.includes("Sample") &&
      !adConfig.messaging_sparks.includes("Drug")
    )
      newRandValue = Math.floor(Math.random() * 3) + 1;
    while (
      newRandValue === 3 &&
      adConfig &&
      adConfig.messaging_sparks.length &&
      !adConfig.messaging_sparks.includes("Rep") &&
      !adConfig.messaging_sparks.includes("Sample") &&
      !adConfig.messaging_sparks.includes("Trial")
    )
      newRandValue = Math.floor(Math.random() * 3) + 1;
    setRandValue(newRandValue);

    const bType = getBannerType();
    setBannerType(bType);

    sessionStorage.setItem("rValue", newRandValue);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const getBannerType = () => {
    const len = adConfig ? adConfig.creative_size.length : 0;
    if (len === 0) return null;
    const newRandValue = Math.floor(Math.random() * len);
    return adConfig.creative_size[newRandValue];
  };

  const getRandomHoriCreative = () => {
    const withCta = adConfig.creative_cta === "With CTAs";
    if (!adConfig) return;
    if (withCta) {
      if (randValue === 1) {
        if (adConfig.messaging_sparks.includes("Rep"))
          return htmls.MedizenHoriAddWithCTARep;
        if (adConfig.messaging_sparks.includes("Sample"))
          return htmls.MedizenHoriAddWithCTASample;
        return htmls.MedizenHoriAddWithCta;
      }
      if (randValue === 2) {
        if (adConfig.messaging_sparks.includes("Rep"))
          return htmls.PrimeraHoriAddWithCTARep;
        if (adConfig.messaging_sparks.includes("Sample"))
          return htmls.PrimeraHoriAddWithCTASample;
        return htmls.PrimeraHoriAddWithCTA;
      }
      if (randValue === 3) {
        if (adConfig.messaging_sparks.includes("Sample"))
          return htmls.PanazHoriAddWithCTASample;
        if (adConfig.messaging_sparks.includes("Rep"))
          return htmls.PanazHoriAddWithCTARep;
        return htmls.PanazHoriAddWithCta;
      }
    } else {
      if (randValue === 1) {
        if (adConfig.messaging_sparks.includes("Sample"))
          return htmls.MedizenHoriAddWithoutCTASample;
        if (adConfig.messaging_sparks.includes("Rep"))
          return htmls.MedizenHoriAddWithoutCTARep;
        return htmls.MedizenHoriAddWithoutCTA;
      }
      if (randValue === 2) {
        if (adConfig.messaging_sparks.includes("Rep"))
          return htmls.PrimeraHoriAddWithoutCTARep;
        if (adConfig.messaging_sparks.includes("Sample"))
          return htmls.PrimeraHoriAddWithoutCTASample;
        return htmls.PrimeraHoriAddWithoutCTA;
      }
      if (randValue === 3) {
        if (adConfig.messaging_sparks.includes("Sample"))
          return htmls.PanazHoriAddWithoutCTASample;
        if (adConfig.messaging_sparks.includes("Rep"))
          return htmls.PanazHoriAddWithoutCTARep;
        return htmls.PanazHoriAddWithoutCTA;
      }
    }
  };
  const getRandomVertCreative = () => {
    const withCta = adConfig.creative_cta === "With CTAs";
    if (!adConfig) return;

    if (withCta) {
      if (randValue === 1) {
        if (adConfig.messaging_sparks.includes("Rep"))
          return htmls.MedizenVertAddWithCTARep;
        if (adConfig.messaging_sparks.includes("Sample"))
          return htmls.MedizenVertAddWithCTASample;
        return htmls.MedizenVertAddWithCta;
      }
      if (randValue === 2) {
        if (adConfig.messaging_sparks.includes("Sample"))
          return htmls.PrimeraVertAddWithCTASample;
        if (adConfig.messaging_sparks.includes("Rep"))
          return htmls.PrimeraVertAddWithCTARep;
        return htmls.PrimeraVertAddWithCTA;
      }
      if (randValue === 3) {
        if (adConfig.messaging_sparks.includes("Rep"))
          return htmls.PanazVertAddWithCTARep;
        if (adConfig.messaging_sparks.includes("Sample"))
          return htmls.PanazVertAddWithCTASample;
        return htmls.PanazVertAddWithCta;
      }
    } else {
      if (randValue === 1) {
        if (adConfig.messaging_sparks.includes("Sample"))
          return htmls.MedizenVertAddWithoutCTASample;
        if (adConfig.messaging_sparks.includes("Rep"))
          return htmls.MedizenVertAddWithoutCTARep;
        return htmls.MedizenVertAddWithoutCTA;
      }
      if (randValue === 2) {
        if (adConfig.messaging_sparks.includes("Rep"))
          return htmls.PrimeraVertAddWithoutCTARep;
        if (adConfig.messaging_sparks.includes("Sample"))
          return htmls.PrimeraVertAddWithoutCTASample;
        return htmls.PrimeraVertAddWithoutCTA;
      }
      if (randValue === 3) {
        if (adConfig.messaging_sparks.includes("Sample"))
          return htmls.PanazVertAddWithoutCTASample;
        if (adConfig.messaging_sparks.includes("Rep"))
          return htmls.PanazVertAddWithoutCTARep;
        return htmls.PanazVertAddWithoutCTA;
      }
    }
  };
  const getRandomReactCreative = () => {
    const withCta = adConfig.creative_cta === "With CTAs";
    if (!adConfig) return;

    if (withCta) {
      if (randValue === 1) {
        if (adConfig.messaging_sparks.includes("Rep"))
          return htmls.MedizenReactAddWithCTARep;
        if (adConfig.messaging_sparks.includes("Sample"))
          return htmls.MedizenReactAddWithCTASample;
        return htmls.MedizenRectAddWithCta;
      }
      if (randValue === 2) {
        if (adConfig.messaging_sparks.includes("Sample"))
          return htmls.PrimeraReactAddWithCTASample;
        if (adConfig.messaging_sparks.includes("Rep"))
          return htmls.PrimeraReactAddWithCTARep;
        return htmls.PrimeraReactAddWithCTA;
      }
      if (randValue === 3) {
        if (adConfig.messaging_sparks.includes("Rep"))
          return htmls.PanazReactAddWithCTARep;
        if (adConfig.messaging_sparks.includes("Sample"))
          return htmls.PanazReactAddWithCTASample;
        return htmls.PanazReactAddWithCta;
      }
    } else {
      if (randValue === 1) {
        if (adConfig.messaging_sparks.includes("Sample"))
          return htmls.MedizenReactAddWithoutCTASample;
        if (adConfig.messaging_sparks.includes("Rep"))
          return htmls.MedizenReactAddWithoutCTARep;
        return htmls.MedizenReactAddWithoutCTA;
      }
      if (randValue === 2) {
        if (adConfig.messaging_sparks.includes("Rep"))
          return htmls.PrimeraReactAddWithoutCTARep;
        if (adConfig.messaging_sparks.includes("Sample"))
          return htmls.PrimeraReactAddWithoutCTASample;
        return htmls.PrimeraReactAddWithoutCTA;
      }
      if (randValue === 3) {
        if (adConfig.messaging_sparks.includes("Sample"))
          return htmls.PanazReactAddWithoutCTASample;
        if (adConfig.messaging_sparks.includes("Rep"))
          return htmls.PanazReactAddWithoutCTARep;
        return htmls.PanazReactAddWithoutCTA;
      }
    }
  };
  const handleOuterClick = () => {
    handleClose();
  };
  const body = (
    <div id="loginSection">
      <ClickAwayListener >
        <div>
          <div
            className="headerArea row row text-center mb-5 pt-5"
            id="headerImg"
          >
            {/* {bannerType === "horizontal" && showAd && (
              <iframe
                style={{ marginLeft: "30%" }}
                srcDoc={getRandomHoriCreative()}
              />
            )} */}
          </div>
          <Grid container className="minH-90">
            <Grid item md={3} xs={12}></Grid>
            <Grid item md={6} xs={12}>
              <LoginSection className={`${classes.paper} `}>
                <LoginFormArea className={classes.loginPaper} id="adsImageDiv">
                  <LoginHeading>EHR Log In</LoginHeading>
                  <CustomDiv marginT="30px">
                    <FlexForm>
                      <Grid container>
                        <Grid item md={5} sm={5} xs={12}>
                          <TextField
                            defaultValue="TomCollins"
                            readOnly="true"
                            label="Username"
                            style={{ width: "100%" }}
                          />
                        </Grid>
                        <Grid item md={2} sm={2} xs={12}>
                          <div style={{ marginBottom: "9px",display: "inline-flex", width: "100%", height: "100%",justifyContent: "center",alignItems: "center" }}>or</div>
                        </Grid>
                        <Grid item md={5} sm={5} xs={12}>
                          <TextField
                            label="NPI"
                            style={{ width: "100%" }}
                          />
                        </Grid>
                      </Grid>
                    </FlexForm>
                    <TextField
                      label="Password"
                      style={{ width: "100%", marginTop: "40px" }}
                      type="password"
                      value="******"
                    />
                    <Button
                      className=""
                      width="100%"
                      marginTop="30px"
                      style={{ fontWeight: 600, fontSize: "18px" }}
                      onClick={handleOnClick}
                    >
                      Log In
                    </Button>
                  </CustomDiv>
                </LoginFormArea>
              </LoginSection>
            </Grid>
            <Grid item md={3} xs={12}></Grid>
          </Grid>
        </div>
      </ClickAwayListener>

      <Ad className="mt-0"></Ad>
      {/* <img src={loginAds1[randValue]} alt="Medizen" className="adsImage" /> */}
      {/* <img src={loginAdsNew[randValue]} alt="Medizen" className="adsImage" /> */}
    </div>
  );

  return (
    <>
      {/* <AiOutlinePlusCircle size="150"  onClick={handleOpen}/> */}
      <div onClick={handleOpen}>
        <img
          src={Plus}
          alt="Plus"
          style={{
            onjectFit: "contain",
            width: "210px",
            borderRadius: "20px",
            border: "0px solid transparent",
            padding: "0px",
          }}
        />
      </div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        className="loginPopupSection"
      >
        <>
          <button className="closeLoginPopup" onClick={handleClose}>X</button>
          {body}
        </>
      </Modal>

    </>
  );
};

export default EhrLogin;
